import axios from "axios";

const consoleApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
consoleApi.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    if (error.response?.status === 401 && !orig._retried && !String(orig.url).includes("/api-console/auth/")) {
      orig._retried = true;
      refreshing = refreshing || consoleApi.post("/api-console/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return consoleApi(orig);
      } catch (e) { /* fall through */ }
    }
    return Promise.reject(error);
  }
);

export default consoleApi;
